/**
 * Site JavaScript entry. Ion bundles this with esbuild on every build into
 * public/assets/js/main.js, which base.html loads. Add behaviour as a module
 * under src/ and import it here.
 */
import { initNav } from "./nav";
import { initCalendar, initUpcoming } from "./calendar";
import { initEntities } from "./entities";
import { initWatch } from "./watch";

function ready(fn: () => void) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

ready(() => {
  initNav();
  initCalendar();
  initWatch();
  initEntities();
  void initUpcoming();
});
